import { ExpressionCondition } from '@/models/audiences';

export type FilterRow = { key: number; condition: ExpressionCondition };
export type FilterGroup = { key: number; rows: FilterRow[] };

export const EMPTY_CONDITION: ExpressionCondition = { type: 'PROPERTY', dataType: 'TEXT' };

export const createInitialFilterGroups = (nextKey: () => number): FilterGroup[] => [
  { key: nextKey(), rows: [{ key: nextKey(), condition: EMPTY_CONDITION }] },
];
